import ParallelList from '../general/ParallelList';
import { useState, useEffect } from 'react';
import apiRegions from '../../api/regions';

const Countries = ({ region, fxAction, title, type }) => {

    const [ items, setItems ] = useState([]);

    useEffect(() => {
        apiRegions.getCountries(region.id).then(({ countries }) => {
            setItems(countries);
        });
    }, [region]);

    return (
        <ParallelList items={items} type={type} action={country => fxAction(country)} title={title} width="w-full" />
    );
};
export default Countries;
